/* eslint-disable max-classes-per-file */
import { ITypeAheadResult } from "~app/common/models/type-ahead-result.model";

export interface IMottagningsplats {
    id: number;
    aktiv: boolean;
    beskrivning?: string;
    ansvarigLogistiker: IAnsvarigLogistiker;
    egenTerminal: boolean;
    mottagningsplatsnummer: string; // 5tecken
    namn: string;
    typeaheadValue: string;
    mottagningsplatstyp: string;
    lagerplatser: ILagerplats[];
    rowVersion: string;
    land: ILand;
    ignoreWarnings: boolean;
    northing: number;
    easting: number;
    terminalKund: IMottagningsplatsCommonTypeAhead;
    terminalCKLeverantor: IMottagningsplatsCommonTypeAhead;
    beraknaNarmasteIndustri: boolean;
}

export class Mottagningsplatstyp {
    static readonly svensk = "svensk";
    static readonly utlandsk = "utlandsk";
}

export interface ILand {
    id: number;
    kod: string;
    namn: string;
    violExport: boolean;
}

export interface IAnsvarigLogistiker {
    namn: string;
    id: number;
    aktiv: boolean;
}

export interface ILagerplats {
    id?: number;
    aktiv: boolean;
    avlamningsplats: string;
    mottagningsplatsKod?: string;
    namn?: string;
    oppettider?: string;
    matmetoder?: string[];
    koordinatN?: number;
    koordinatE?: number;
    finnsIViol3?: boolean;
    rowVersion?: string;
}

export interface IMottagningsplatsCommonTypeAhead {
    namn: string;
    id: number;
    kod: string;
    aktiv: boolean;
}

export interface ISDCMottagningsplats {
    namn: string;
    site: string;
    aktiv: boolean;
    northing: number;
    easting: number;
    lagerplatser: ISDCLagerplats[];
}

export interface ISDCLagerplats {
    namn: string;
    kod: string;
    easting: number;
    northing: number;

}
export interface IDeleteMottagningsplats {
    id: number;
    rowVersion: string;
}

export class Mottagningsplats implements IMottagningsplats {
    id: number;
    aktiv: boolean;
    beskrivning?: string;
    ansvarigLogistiker: IAnsvarigLogistiker;
    egenTerminal: boolean;
    mottagningsplatsnummer: string; // 5tecken
    namn: string;
    typeaheadValue: string;
    mottagningsplatstyp: string;
    site: string;
    lagerplatser: ILagerplats[];
    rowVersion: string;
    land: ILand;
    ignoreWarnings: boolean;
    terminalKund: IMottagningsplatsCommonTypeAhead;
    terminalCKLeverantor: IMottagningsplatsCommonTypeAhead;
    northing: number;
    easting: number;
    beraknaNarmasteIndustri: boolean;
    finnsIViol3: boolean;

    constructor() {
        this.aktiv = true;
    }

    static createInstance(name: string, aktiv: boolean) {

        const mottagningsplats = new Mottagningsplats();
        mottagningsplats.namn = name;
        mottagningsplats.aktiv = aktiv;
        mottagningsplats.egenTerminal = false;
        mottagningsplats.typeaheadValue = mottagningsplats.namn;

        return mottagningsplats;
    }

    static createInstanceFromTypeAhead(typeahead: ITypeAheadResult) {

        if (typeahead == null) {
            return null;
        }
        const mottagningsplats = new Mottagningsplats();
        mottagningsplats.namn = typeahead.namn;
        mottagningsplats.mottagningsplatsnummer = typeahead.kod;
        mottagningsplats.aktiv = typeahead.aktiv;
        mottagningsplats.egenTerminal = false;

        mottagningsplats.typeaheadValue = `${mottagningsplats.mottagningsplatsnummer} - ${mottagningsplats.namn}`;

        return mottagningsplats;
    }

    static createListfromTypeAhead(typeaheadList: ITypeAheadResult[]) {

        const mottagningsplatsList: Mottagningsplats[] = [];
        typeaheadList.forEach(typeahead => {
            mottagningsplatsList.push(this.createInstanceFromTypeAhead(typeahead));
        });

        return mottagningsplatsList;
    }
}

export interface IMottagningsplatsgrunddata {
    lander: ILand[];
}

export interface IMatmetoder {
    id: number;
    kod: string;
    namn: string;
    kortNamn: string;
    aktiv: boolean;
}

export interface ISearchMottagningsplatsQueryResult {
    id: number;
    mottagningsplatsnummer: string;
    namn: string;
    egenTerminal: string;
    lagerplatser: ISearchMottagningsplatsQueryLagerplatsResult[];
}

export interface ISearchMottagningsplatsQueryLagerplatsResult {
    id: number;
    namn: string;
    avlamningsplats: string;
    finnsIViol3: boolean;
}
